module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "header-top",
    staticStyle: {
      "background": "#fffaec",
      "padding": "10px 0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('el-col', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "span": 12,
      "xs": 20
    }
  }, [_c('div', {
    staticClass: "logo-area"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px",
      "margin-top": "0"
    },
    attrs: {
      "src": "static/assets/images/logo-light.png",
      "alt": "logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "fontfamily",
    staticStyle: {
      "justify-content": "center",
      "align-self": "center",
      "font-weight": "600",
      "margin-left": "20px"
    }
  }, [_vm._v("\n            MOUNT GAMBIER BREWERY\n          ")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "justify-content": "center",
      "align-self": "center",
      "display": "flex"
    },
    attrs: {
      "span": 12,
      "xs": 4
    }
  }, [_c('div', {
    staticClass: "custom-navbar",
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', {
    staticStyle: {
      "top": "110px"
    }
  }, [_c('li', [_c('router-link', {
    staticClass: "custom-navbarli",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("OPEN AND CLOSE")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "custom-navbarli",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "to": "/category"
    }
  }, [_vm._v("VENUE")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "custom-navbarli",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "to": "/blogDetails"
    }
  }, [_vm._v("MENU")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "custom-navbarli",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("CONTACT")])], 1)])])])], 1)])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "merquee"
  }, [_c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")]), _vm._v(" "), _c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")]), _vm._v(" "), _c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "merquee"
  }, [_c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")]), _vm._v(" "), _c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")]), _vm._v(" "), _c('span', {
    staticClass: "merquee-txt"
  }, [_vm._v("    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER    ★    AMERICAN BBQ    ★    BREW HOUSE    ★\n          CRAFT BEER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-area",
    staticStyle: {
      "padding": "20px 0",
      "background": "#444447"
    }
  }, [_c('div', {
    staticClass: "footer-copyright",
    staticStyle: {
      "margin-top": "0px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "14px"
    }
  }, [_vm._v("\n          © 2024, mount gambier brewery pty ltd\n        ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99d14426"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 243
// module chunks = 1